import { render, staticRenderFns } from "./UmsUserBarcodeViewer.vue?vue&type=template&id=0d17a925&"
import script from "./UmsUserBarcodeViewer.vue?vue&type=script&lang=js&"
export * from "./UmsUserBarcodeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports